import React from 'react';
import './HamburgerMenu.css';

const HamburgerMenu = ({ isOpen, toggleMenu }) => {
  return (
    <div className="hamburger-menu" onClick={toggleMenu}>
      <div className={isOpen ? 'bar open' : 'bar'}></div>
      <div className={isOpen ? 'bar open' : 'bar'}></div>
      <div className={isOpen ? 'bar open' : 'bar'}></div>
    </div>
  );
};

export default HamburgerMenu;